import { useEffect, useRef } from "react";
import { addMonths, isEqual, startOfMonth } from "../../../../date-fns/index.js";
import { useCalendarConfiguration } from "../CalendarRoot.js";
function useFocusOnSelection(selection, focusOnSelection) {
  const config = useCalendarConfiguration();
  const { referenceDate, setReferenceDate } = config;
  const referenceDateRef = useRef(referenceDate);
  useEffect(() => {
    referenceDateRef.current = referenceDate;
  }, [referenceDate]);
  useEffect(() => {
    if (!focusOnSelection || !selection) return;
    const selectionStartOfMonth = startOfMonth(selection);
    if (!isEqual(selectionStartOfMonth, referenceDateRef.current) && !isEqual(selectionStartOfMonth, addMonths(referenceDateRef.current, 1))) {
      setReferenceDate(selectionStartOfMonth);
    }
  }, [setReferenceDate, focusOnSelection, selection]);
}
export {
  useFocusOnSelection
};
//# sourceMappingURL=useFocusOnSelection.js.map
